import { RANKINGS } from '../../data';
import s from '../../styles/dashboard.module.css';

// Compact top-5 staff leaderboard shown in the sidebar.
export function SidebarRankings() {
  return (
    <div>
      {RANKINGS.slice(0, 5).map((r, i) => (
        <div key={r.name} className={s.rankItem}>
          <span className={`${s.rankNum} ${i === 0 ? s.gold : ''}`}>{String(i + 1).padStart(2, '0')}</span>
          <span className={s.rankName} style={{ fontSize: 10 }}>{r.name.split(' ')[0]}</span>
          <span className={s.rankPts}>{r.pts}pts</span>
        </div>
      ))}
    </div>
  );
}
